import { useState, useEffect } from "react";
import { useConversations } from "../contexts/ConversationsProvider";

export function useUnreadMessages(userId) {
  const { conversations } = useConversations();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (!conversations || !userId) {
      setUnreadCount(0);
      return;
    }

    let totalUnread = 0;
    conversations.forEach((conversation) => {
      if (conversation.messages) {
        conversation.messages.forEach((message) => {
          if (!message.readStatus && message.sender !== userId) {
            totalUnread++;
          }
        });
      }
    });

    setUnreadCount(totalUnread);
  }, [conversations, userId]);

  return unreadCount;
}
